document.addEventListener("DOMContentLoaded", () => {

    const peopleItems = document.querySelectorAll('.js-teaser__person');
    const filterPillsContainer = document.querySelector('.js-filter__pills');
    const dropdownButtons = document.querySelectorAll('.js-filter__btn-location, .js-filter__btn-role');
    const dropdownFlyouts = document.querySelectorAll('.js-filter__flyout-location, .js-filter__flyout-role');

    // toggle buttons
    dropdownButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            e.stopPropagation();

            const isLocation = button.classList.contains('js-filter__btn-location');
            const flyout = document.querySelector(isLocation ? '.js-filter__flyout-location' : '.js-filter__flyout-role');

            // close other open dropdowns
            dropdownButtons.forEach(btn => {
                if (btn !== button) btn.classList.remove('open');
            });
            dropdownFlyouts.forEach(fly => {
                if (fly !== flyout) fly.classList.remove('open');
            });

            // toggle current dropdown
            button.classList.toggle('open');
            flyout.classList.toggle('open');
        });
    });

    // close dropdowns on click outside
    document.addEventListener('click', (e) => {
        const clickedInside = Array.from(dropdownFlyouts).some(flyout => flyout.contains(e.target));
        const clickedOnBtn = Array.from(dropdownButtons).some(btn => btn.contains(e.target));

        if (!clickedInside && !clickedOnBtn) {
            dropdownButtons.forEach(btn => btn.classList.remove('open'));
            dropdownFlyouts.forEach(flyout => flyout.classList.remove('open'));
        }
    });

    // get query params on page load
    function getQueryParams() {
        const params = new URLSearchParams(window.location.search);
        const obj = {};
        for (const [key, value] of params.entries()) {
            if (!obj[key]) obj[key] = [];
            obj[key].push(value);
        }
        return obj;
    }

    // update URL query params on add/remove filter
    function updateQueryParams() {
        const activeFilters = Array.from(
            document.querySelectorAll("input[type='checkbox']:checked")
        ).map(c => c.value);

        const locations = [];
        const roles = [];

        activeFilters.forEach(val => {
            const checkbox = document.querySelector(`input[type="checkbox"][value='${val}']`);
            if (!checkbox) return;
            if (checkbox.name.includes('location')) locations.push(val);
            else if (checkbox.name.includes('role')) roles.push(val);
        });

        const params = new URLSearchParams();
        locations.forEach(loc => params.append('location', loc));
        roles.forEach(role => params.append('role', role));

        const newUrl = `${window.location.pathname}?${params.toString()}`;
        history.replaceState(null, '', newUrl); // push to history
    }

    function applyQueryParams() {
        const params = getQueryParams();

        Object.entries(params).forEach(([key, values]) => {
            values.forEach(val => {
                const checkbox = document.querySelector(`input[name*='${key}'][value='${val}']`);
                if (checkbox) {
                    checkbox.checked = true;
                    const label = document.querySelector(`label[for='${checkbox.id}']`).textContent.trim();
                    addPill(val, label);
                }
            });
        });

        filterPeople();
    }

    // listen to checkbox change in dropdowns
    document.addEventListener('change', (event) => {
        const checkbox = event.target;
        if (checkbox.type !== "checkbox") return;

        const value = checkbox.value;
        const label = document.querySelector(`label[for='${checkbox.id}']`).textContent.trim();

        if (checkbox.checked) {
            addPill(value, label);
        } else {
            removePill(value);
        }

        filterPeople();
        updateQueryParams();
    });

    function addPill(value, label) {
        if (document.querySelector(`[data-filter-pill='${value}']`)) return;

        const pillTpl = document.querySelector('.js-filter__pill:not(.is-added)');

        if (pillTpl) {
            // clone tpl
            const pill = pillTpl.cloneNode(true);
            pill.classList.add('is-added');

            const button = pill.querySelector('button');
            button.setAttribute('data-filter-pill', value);
            button.querySelector('span').textContent = label;

            // add to container
            filterPillsContainer.appendChild(pill);

            // add click event
            button.addEventListener('click', () => {
                removeSelection(value);
            });
        }
    }

    function removePill(value) {
        const pill = document.querySelector(`.js-filter__pill button[data-filter-pill='${value}']`);
        if (pill) pill.parentElement.remove();
    }

    // uncheck checkbox if pill is removed
    function removeSelection(value) {
        const checkbox = document.querySelector(`input[type="checkbox"][value='${value}']`);
        if (checkbox) checkbox.checked = false;
        removePill(value);
        filterPeople();
        updateQueryParams();
    }

    function updateResultLabel() {
        const resultSummary = document.querySelector('.js-filter__result-summary');
        const resultLabel = document.querySelector('.js-filter__result-label');
        const resultCountEl = resultLabel?.querySelector('.js-filter__result-label--count');
        const resultTextEl = resultLabel?.querySelector('.js-filter__result-label--text');
        const resultContainer = document.querySelector('.js-filter__result');

        const activeFilters = Array.from(
            document.querySelectorAll('input[type="checkbox"]:checked')
        );

        const visibleItems = Array.from(peopleItems)
            .filter(item => item.style.display !== 'none');

        const count = visibleItems.length;

        // toggle result container visibility based on results
        if (count === 0 && activeFilters.length > 0) {
            resultContainer?.classList.add('is-hidden');
        } else {
            resultContainer?.classList.remove('is-hidden');
        }

        // no active filters? hide everything.
        if (activeFilters.length === 0) {
            resultSummary?.classList.remove('is-visible');
            if (resultLabel) resultLabel.style.display = 'none';
            return;
        }

        // show summary, if there are active filters
        resultSummary?.classList.add('is-visible');

        // update count
        if (count > 0 && resultCountEl) {
            resultCountEl.textContent = count;
        } else if (resultCountEl) {
            resultCountEl.textContent = '';
        }

        let text = '';
        if (count === 0) {
            text = resultTextEl?.dataset.filterLabelNoresults || '';
        } else if (count === 1) {
            text = resultTextEl?.dataset.filterLabelSingular || '';
        } else {
            text = resultTextEl?.dataset.filterLabelPlural || '';
        }

        if (resultTextEl) resultTextEl.textContent = text;
        if (resultLabel) resultLabel.style.display = 'block';
    }

    // filtering logic:
    // OR within category, AND between categories
    // example: 'director' or 'assistant' AND 'st.gallen'
    function filterPeople() {
        const allCheckboxes = document.querySelectorAll('input[type="checkbox"]:checked');

        const selectedLocations = [];
        const selectedRoles = [];

        allCheckboxes.forEach(checkbox => {
            const value = checkbox.value;
            if (checkbox.name.includes('location')) {
                selectedLocations.push(value);
            } else if (checkbox.name.includes('role')) {
                selectedRoles.push(value);
            }
        });

        // show all, if nothing selected
        if (selectedLocations.length === 0 && selectedRoles.length === 0) {
            peopleItems.forEach(item => item.style.display = '');
            updateResultLabel();
            return;
        }

        peopleItems.forEach(item => {
            const personLocations = (item.dataset.personLocations || '').split(',').filter(v => v);
            const personRoles = (item.dataset.personRoles || '').split(',').filter(v => v);

            // check location match (OR within locations)
            const locationMatch = selectedLocations.length === 0 ||
                selectedLocations.some(loc => personLocations.includes(loc));

            // check role match (OR within roles)
            const roleMatch = selectedRoles.length === 0 ||
                selectedRoles.some(role => personRoles.includes(role));

            // match both categories (AND between categories)
            const match = locationMatch && roleMatch;

            item.style.display = match ? '' : 'none';
        });

        // update the result labels: wrapper, count, text
        updateResultLabel();
    }

    // apply query params on page load to filter
    applyQueryParams();
});